import {api} from '../utils/http-common'

class AuthService {
  login(payload?: FormData) {
    return api.post<any>("auth/login", payload);
  }
  me<R = any>(){
    return api.get<any,R>("auth/me");
  }
  logout(){
    return api.get("auth/logout");
  }
}

const authService = new AuthService();
export default authService